import { __assign, __read, __spreadArray } from "tslib";
import { useCallback } from 'react';
import { useControlled } from '../../../../utils/hooks/useControlled';
export function useControlledCheckboxGroup(_a) {
    var valuesProp = _a.values, defaultValuesProp = _a.defaultValues, changeHandlerProp = _a.changeHandler, componentName = _a.componentName, nameAttribute = _a.nameAttribute;
    var nameForCheckboxes = nameAttribute
        ? nameAttribute.endsWith('[]')
            ? nameAttribute
            : nameAttribute + '[]'
        : undefined;
    var _b = __read(useControlled({
        controlled: valuesProp,
        default: defaultValuesProp || [],
        name: componentName,
        state: 'values',
    }), 2), values = _b[0], setValues = _b[1];
    var changeHandler = useCallback(function (e) {
        var _a = e.target, checked = _a.checked, value = _a.value;
        var currentValues = values || [];
        var newValues = checked
            ? __spreadArray(__spreadArray([], __read(currentValues)), [value]) : currentValues.filter(function (v) { return v !== value; });
        setValues(newValues);
        changeHandlerProp === null || changeHandlerProp === void 0 ? void 0 : changeHandlerProp({
            values: newValues,
            name: nameAttribute,
        });
    }, [changeHandlerProp, nameAttribute, values]);
    function isChecked(option) {
        return values === undefined ? false : values.includes(option.value);
    }
    function getOptionProps(option) {
        var checked = isChecked(option);
        return __assign(__assign({}, option), { checked: checked, name: nameForCheckboxes, onChange: changeHandler });
    }
    return {
        values: values,
        changeHandler: changeHandler,
        nameForCheckboxes: nameForCheckboxes,
        isChecked: isChecked,
        getOptionProps: getOptionProps,
    };
}
//# sourceMappingURL=useControlledCheckboxGroup.js.map